module.exports = __webpack_public_path__ + "img/icon-account-deactivate-white@3x.c6feaeff.png";